import React from "react"
import PropTypes from "prop-types"
import cx from "classnames"
import Text from "@kit/design/text"
import { OldButton } from "@kit/design/old-button"
import Stack from "@kit/design/stack"
import Icon from "@kit/design/icon"
import { MediaGalleryLogos } from "./media-gallery-logos"
import { DismissButton } from "./dismiss-button"

const TEXT =
  "Connect tools like Canva, Giphy, and Pinterest to add rich media to your emails."

// Using a regular button link instead of core/link because this component is used by file
// gallery which is used in functions.js which cannot use inertia.
const BrowseMoreAppsLink = ({ size, href, onClick }) => {
  return (
    <OldButton
      href={href}
      is="tertiary"
      size={size}
      className="gap-2"
      onClick={onClick}
    >
      Do more with apps
      <Icon name="arrow-right" />
    </OldButton>
  )
}

/**
 * The card variant of the App Discoverability CTA used in the media gallery.
 */
export function AppDiscoverabilityCard({
  size = "md",
  href = "/apps",
  className,
  onClick,
  onDismiss
}) {
  return (
    <Stack
      spacing={3}
      className={cx("bg-gray-50 p-4 rounded-lg relative", className)}
    >
      {size === "sm" ? (
        <>
          <DismissButton
            onDismiss={onDismiss}
            className="absolute"
            style={{ top: ".5rem", right: ".5rem" }}
          />
          <Text size="sm">{TEXT}</Text>
          <div className="flex gap-2 items-center">
            <MediaGalleryLogos />
            <BrowseMoreAppsLink size="sm" href={href} onClick={onClick} />
          </div>
        </>
      ) : (
        <>
          <MediaGalleryLogos onDismiss={onDismiss} />
          <Text size="sm">{TEXT}</Text>
          <BrowseMoreAppsLink size="md" href={href} onClick={onClick} />
        </>
      )}
    </Stack>
  )
}

AppDiscoverabilityCard.propTypes = {
  size: PropTypes.oneOf(["sm", "md"]),
  href: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired
}
